import { render, staticRenderFns } from "./PreviewNavigation.vue?vue&type=template&id=2e8a1e20&scoped=true"
import script from "./PreviewNavigation.vue?vue&type=script&lang=js"
export * from "./PreviewNavigation.vue?vue&type=script&lang=js"
import style0 from "./PreviewNavigation.vue?vue&type=style&index=0&id=2e8a1e20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8a1e20",
  null
  
)

export default component.exports